import GuideApi from "apis/guideApi";
import { ActionTypes } from "store/actionTypes";
import { AppDispatch } from "store";

const api = new GuideApi();

export const getGuides =
  (customerId?: string) => async (dispatch: AppDispatch) => {
    dispatch({ type: ActionTypes.GUIDE_LOADING });
    try {
      const response = await api.getGuides(customerId);
      dispatch({ type: ActionTypes.GET_GUIDES, payload: response });
    } catch (error: any) {
      dispatch({ type: ActionTypes.GUIDE_ERROR, payload: error.message });
    }
  };

export const getGuideById =
  (id: string | number) => async (dispatch: AppDispatch) => {
    dispatch({ type: ActionTypes.GUIDE_LOADING });
    try {
      const response = await api.getGuideById(id);
      dispatch({ type: ActionTypes.GET_GUIDE_BY_ID, payload: response });
    } catch (error: any) {
      dispatch({ type: ActionTypes.GUIDE_ERROR, payload: error.message });
    }
  };

export const addGuide = (guide: any) => async (dispatch: AppDispatch) => {
  dispatch({ type: ActionTypes.GUIDE_LOADING });
  try {
    const response = await api.addGuide(guide);
    dispatch({ type: ActionTypes.ADD_GUIDE, payload: response });
  } catch (error: any) {
    dispatch({ type: ActionTypes.GUIDE_ERROR, payload: error.message });
  }
};

export const updateGuide = (guide: any) => async (dispatch: AppDispatch) => {
  dispatch({ type: ActionTypes.GUIDE_LOADING });
  try {
    const response = await api.updateGuide(guide);
    dispatch({
      type: ActionTypes.UPDATE_GUIDE,
      payload: { ...guide, ...response },
    });
  } catch (error: any) {
    dispatch({ type: ActionTypes.GUIDE_ERROR, payload: error.message });
  }
};

export const deleteGuide =
  (id: string | number) => async (dispatch: AppDispatch) => {
    dispatch({ type: ActionTypes.GUIDE_LOADING });
    try {
      await api.deleteGuide(id);
      dispatch({ type: ActionTypes.DELETE_GUIDE, payload: id });
    } catch (error: any) {
      dispatch({ type: ActionTypes.GUIDE_ERROR, payload: error.message });
    }
  };

export const setGuideCustomerSelection = (customerId: string | null) => {
  return { type: ActionTypes.SET_GUIDE_CUSTOMER_SELECTION, payload: customerId };
};
